import { MultiSelectTagPicker } from '@shared/components';
import { TPickerItem } from '@shared/types';
import { TSparseItem } from '@modules/items';

export type TPickerProduct = TPickerItem<TSparseItem>;

type TProps = {
  label?: string;
  placeholder?: string;
  products: TPickerProduct[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  required?: boolean;
  validationMessage?: string;
  disabled?: boolean;
  className?: string;
  variant?: 'tags' | 'summary';
};

const ProductPicker = ({
  label,
  placeholder = 'Search products',
  products,
  selectedIds,
  onChange,
  required,
  validationMessage,
  disabled = false,
  className,
  variant,
}: TProps) => {
  return (
    <MultiSelectTagPicker
      options={products.map((product) => ({
        value: product._id,
        label: product.name,
        disabledReason: product.disabledReason,
      }))}
      selectedOptions={selectedIds}
      onChange={onChange}
      inputAriaLabel="Select products"
      selectedAriaLabel="Selected products"
      noMatchesMessage="No matching product."
      label={label}
      placeholder={placeholder}
      required={required}
      validationMessage={validationMessage}
      disabled={disabled}
      className={className}
      variant={variant}
    />
  );
};

export default ProductPicker;
